import { render, staticRenderFns } from "./leftcard3.vue?vue&type=template&id=6d4c299c&scoped=true"
import script from "./leftcard3.vue?vue&type=script&lang=js"
export * from "./leftcard3.vue?vue&type=script&lang=js"
import style0 from "./leftcard3.vue?vue&type=style&index=0&id=6d4c299c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c299c",
  null
  
)

export default component.exports